import { render } from "./quill-editor.vue?vue&type=template&id=460c0bcc&ts=true"
import script from "./quill-editor.vue?vue&type=script&lang=ts"
export * from "./quill-editor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__